const FORMAT_OPTS = { minimumFractionDigits: 2, maximumFractionDigits: 2 }
const FORMATTER = new Intl.NumberFormat('en-US', FORMAT_OPTS)

export function formatCurrency(value) {
  const n = Number(value)
  return FORMATTER.format(Number.isNaN(n) ? 0 : n)
}

export function formatInt(value) {
  const n = Number(value)
  return (Number.isNaN(n) ? 0 : n).toLocaleString('en-US')
}
